<template>
  <div class="dados">
    <h1 class="font-weight-bold text-uppercase ml-2" id="inicio">Meus Dados</h1>
    <hr class="linha-amarela ml-2" />

    <div class="row col justify-content-center my-4">
      <div class="mt-2 ml-4">
        <button
          class="btn shadow bg-light rounded py-3"
          style="min-width: 200px"
        >
          <router-link
            class="font-weight-bold no-text-decoration d-flex align-items-center"
            :to="{ name: 'guia-profissionais-geral' }"
          >
            <i class="fas fa-hard-hat c-orange fa-2x mr-2"></i>
            <span class="c-gray-3"> Guia de Profissionais </span>
          </router-link>
        </button>
      </div>
      <button
        class="mt-2 mb-2 ml-4 btn shadow bg-light rounded py-3"
        style="min-width: 208px"
      >
        <router-link
          class="font-weight-bold no-text-decoration d-flex align-items-center"
          :to="{ name: 'fazer-cotacao' }"
        >
          <i class="fas fa-tags c-orange fa-2x mr-2"></i>
          <span class="c-gray-3"> Fazer orçamento </span>
        </router-link>
      </button>
    </div>

    <div class="container col">
      <i class="fas fa-sign-in-alt fa-2x c-orange mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Dados de Acesso
      </h4>

      <div class="row col mt-3">
        <div class="col-md-6 form-group">
          <label for="email" class="font-weight-bold">E-mail:</label><br />
          <input
            type="text"
            class="form-control"
            v-model="dados.email.value"
            :placeholder="dados.email.placeholder"
          />
        </div>

        <div class="col-md-6 form-group">
          <label class="font-weight-bold">Senha:</label><br />
          <input
            type="password"
            class="form-control"
            v-model="dados.senha.value"
            placeholder="******"
          />
        </div>
      </div>

      <hr />

      <i class="fas fa-user-circle c-orange fa-2x mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Dados da Conta
      </h4>
      <div class="row">
        <div class="col-md-12">
          <div class="row col-12 mt-3">
            <div class="form-group col-md-6">
              <label for="nome" class="font-weight-bold">Nome:</label><br />
              <input
                type="text"
                class="form-control"
                v-model="dados.nome.value"
                :placeholder="dados.nome.placeholder"
              />
            </div>

            <div class="form-group col-md-6">
              <label class="font-weight-bold">RG:</label><br />
              <input
                type="text"
                class="form-control"
                v-mask="'##.###.###-X'"
                v-model="dados.rg.value"
                :placeholder="dados.rg.placeholder"
              />
            </div>

            <div class="form-group col-md-6">
              <label class="font-weight-bold">CPF:</label><br />
              <input
                type="text"
                class="form-control"
                v-mask="'###.###.###-##'"
                v-model="dados.cpf.value"
                :placeholder="dados.cpf.placeholder"
              />
            </div>

            <div class="form-group col-md-6">
              <label class="font-weight-bold">CNPJ:</label><br />
              <input
                type="text"
                class="form-control"
                v-mask="'##.###.###/####-##'"
                v-model="dados.cnpj.value"
                :placeholder="dados.cnpj.placeholder"
              />
            </div>
          </div>

          <div class="row col-12">
            <div class="form-group col-md-4">
              <label class="font-weight-bold">Whatsapp:</label>
              <input
                type="text"
                class="form-control"
                id="whatsapp"
                name="whatsapp"
                v-model="dados.celular.value"
                v-mask="['(##) #####-####', '(##) ####-####']"              
              />     
            </div>

            <div class="form-group col-md-4">
              <label for="telefone" class="font-weight-bold"> Telefone: </label>
              <input
                type="text"
                class="form-control"
                id="telefone"
                name="telefone"
                v-model="dados.telefone.value"
                v-mask="'(##) #####-####'"
              />     
            </div>

            <div class="form-group col-md-4">
              <label for="telefone2" class="font-weight-bold">
                Telefone 2:
              </label>
              <input
                type="text"
                class="form-control"
                id="telefone2"
                name="telefone2"
                v-model="dados.telefone2.value"
                v-mask="'(##) #####-####'"
              />
            </div>
          </div>

          <div class="col mt-2 mb-3">
            <button class="btn btn-success text-white" @click="editarCliente()">
              Salvar dados
            </button>
          </div>
        </div>
      </div>

      <hr />

      <i class="fa fa-map-marked-alt c-orange fa-2x mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Endereço
      </h4>
      <div class="row">
        <div class="col mt-3">
          <Endereco />
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col mt-3">
          <AcceptNotifications />
        </div>
      </div>
    </div>

    <b-modal
      v-if="this['login/getNeedDefinePassword']"
      title="Defina uma senha para sua conta da Constr Up"
      size="xl"
      id="definePassword"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      no-close-on-backdrop
    >
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="password"> Senha </label>
            <input
              type="password"
              class="form-control"
              id="password"
              name="password"
              v-model="definePassword.password"
              placeholder="Digite sua senha"
              @input="ErrorMessages.password = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.password !== null"
            >
              {{ ErrorMessages.password }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="confirmPassword"> Confirme sua senha </label>
            <input
              type="password"
              class="form-control"
              id="confirmPassword"
              name="confirmPassword"
              v-model="definePassword.confirmPassword"
              placeholder="Digite sua senha novamente"
              @input="ErrorMessages.confirmPassword = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.confirmPassword !== null"
            >
              {{ ErrorMessages.confirmPassword }}
            </p>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div>
          <button
            type="button"
            class="btn btn-success btn-lg"
            @click="defineClientPassword()"
          >
            Definir senha
            <i class="fas fa-check-circle ml-2"></i>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import makeToast from "../../mixins/makeToast";
import Endereco from "../cliente/Endereco";
import AcceptNotifications from "../../components/AcceptNotifications";
import scrollToElement from "../../mixins/scrollToElement";

export default {
  name: "dados",
  mixins: [makeToast, scrollToElement],
  components: {
    Endereco,
    AcceptNotifications,
  },
  data: () => ({
    dados: {
      email: {
        value: null,
        placeholder: null,
        show: false,
      },
      senha: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome: {
        value: null,
        placeholder: null,
        show: false,
      },
      rg: {
        value: null,
        placeholder: null,
        show: false,
      },
      cpf: {
        value: null,
        placeholder: null,
        show: false,
      },
      cnpj: {
        value: null,
        placeholder: null,
        show: false,
      },
      celular: {
        value: null,
        placeholder: null,
        show: false,
      },
      telefone: {
        value: null,
        placeholder: null,
        show: false,
      },
      telefone2: {
        value: null,
        placeholder: null,
        show: false,
      },
      modificarEndNumShow: false,
      modificarBaiCidEstShow: false,
    },
    definePassword: {
      password: null,
      confirmPassword: null,
    },
    ErrorMessages: {
      password: null,
      confirmPassword: null,
    },
  }),
  computed: {
    ...mapState(['token', 'dadosUsuario', 'estados', 'cidades']),
    ...mapGetters([
      'getTipoNotification',
      'getNotification',
      'login/getNeedDefinePassword',
    ]),
  },
  created() {
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadEstados');
    this.scrollToElement();
  },
  mounted() {
    this.scrollToElement();
    if (this['login/getNeedDefinePassword']) {
      this.$bvModal.show('definePassword');
    }
  },
  beforeMount() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'area-restrita' });
    }
    this.dados.email.placeholder = this.dadosUsuario.email;
    this.dados.nome.placeholder = this.dadosUsuario.informacoes.nome;
    this.dados.rg.placeholder = this.dadosUsuario.rg;
    this.dados.cpf.placeholder = this.dadosUsuario.cpf;
    this.dados.cnpj.placeholder = this.dadosUsuario.cnpj;
    this.dados.celular.placeholder = this.dadosUsuario.informacoes.celular;
    this.dados.telefone.placeholder = this.dadosUsuario.informacoes.telefone;
    this.dados.telefone2.placeholder = this.dadosUsuario.informacoes.telefone2;

    this.dados.email.value = this.dadosUsuario.email;
    this.dados.nome.value = this.dadosUsuario.informacoes.nome;
    this.dados.rg.value = this.dadosUsuario.rg;
    this.dados.cpf.value = this.dadosUsuario.cpf;
    this.dados.cnpj.value = this.dadosUsuario.cnpj;
    this.dados.celular.value = this.dadosUsuario.informacoes.celular;
    this.dados.telefone.value = this.dadosUsuario.informacoes.telefone;
    this.dados.telefone2.value = this.dadosUsuario.informacoes.telefone2;
  },
  beforeUpdate() {
    if (this.$router.history.current.name === "cadastro") {

      if (this.checkIsEmpty(this.token)) {
        this.$router.push({ name: 'area-restrita' });
      }
    }
  },
  methods: {
    ...mapActions('login', ['needDefinePassword']),
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    modificarEndNum() {
      this.dados.modificarEndNumShow = !this.dados.modificarEndNumShow;
    },
    modificarBaiCidEst() {
      this.dados.modificarBaiCidEstShow = !this.dados.modificarBaiCidEstShow;
    },
    // ********************************************************************************************************************
    // verificaEdicao() {
    //   if (
    //     this.dados.email.show !== false ||
    //     this.dados.nome.show !== false ||
    //     this.dados.rg.show !== false ||
    //     this.dados.cpf.show !== false ||
    //     this.dados.cnpj.show !== false ||
    //     this.dados.celular.show !== false ||
    //     this.dados.telefone.show !== false ||
    //     this.dados.telefone2.show !== false ||
    //     this.dados.senha.show !== false
    //   ) {
    //     return true;
    //   }
    //   return false;
    // },

    editarCliente() {
      const self = this;
      const data = {
        id: this.dadosUsuario.id,
        id_cliente: this.dadosUsuario.informacoes.id,
      };

      Object.assign(data, { email: this.dados.email.value });
      Object.assign(data, { nome: this.dados.nome.value });
      Object.assign(data, { rg: this.dados.rg.value });
      Object.assign(data, { cpf: this.dados.cpf.value });
      Object.assign(data, { cnpj: this.dados.cnpj.value });
      Object.assign(data, { celular: this.dados.celular.value });
      Object.assign(data, { telefone: this.dados.telefone.value });
      Object.assign(data, { telefone2: this.dados.telefone2.value });

      if (this.dados.senha.value !== null) {
        Object.assign(data, { password: this.dados.senha.value });
      }

      // console.log(data)

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateCliente', data)
        .then(() => {
          this.makeToast(
            'sucesso',
            'Dados atualizados com sucesso!',
            'success'
          );
          self.dados.email.show = false;
          self.dados.nome.show = false;
          self.dados.rg.show = false;
          self.dados.cpf.show = false;
          self.dados.cnpj.show = false;
          self.dados.celular.show = false;
          self.dados.telefone.show = false;
          self.dados.telefone2.show = false;
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao atualizar!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    },
    defineClientPassword() {
      if (this.validatePassword()) {
        this.$store.dispatch('startLoader');

        const data = {
          usuario_id: this.dadosUsuario.informacoes.usuario_id,
          password: this.definePassword.password,
        };

        this.$store
          .dispatch('user/definePassword', data)
          .then(() => {
            this.$store.dispatch('endLoader');
            this.makeToast('Sucesso!', 'Senha definida com sucesso!');
            this.$bvModal.hide('definePassword');
            this.needDefinePassword(false);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast(
              'Oopss!',
              'Parece que houve um erro ao definir sua senha, tente novamente mais tarde',
              'danger'
            );
          });
      } else {
        this.$store.dispatch('endLoader');
        this.makeToast(
          'Campos inválidos',
          'Parece que há campos inválidos, corrija-os e tente novamente!',
          'danger'
        );
      }
    },
    validatePassword() {
      let isValid = true;

      if (!this.$validate.password(this.definePassword.password)) {
        this.ErrorMessages.password =
          'A senha precisa ter no mínimo 5 caracteres';
        isValid = false;
      }

      if (
        this.definePassword.confirmPassword !== this.definePassword.password
      ) {
        this.ErrorMessages.confirmPassword = 'As senhas devem ser iguais';
        isValid = false;
      }

      return isValid;
    },
  },
};
</script>
